import type { TFunction } from 'i18next';

export const REPORT_ERROR_CODE = {
    NETWORK: 'network',
    INTERNAL: 'internal_error',
    TIMEOUT: 'timeout',
    EMPTY: 'empty_report',
} as const;

const INTERNAL_ERROR_CODES = new Set<string>([
    REPORT_ERROR_CODE.NETWORK,
    REPORT_ERROR_CODE.INTERNAL,
    'request_failed',
]);

const TECHNICAL_ERROR_PATTERNS = [
    /cannot read propert/i,
    /undefined is not/i,
    /null is not/i,
    /\bTypeError\b/i,
    /\bReferenceError\b/i,
    /\bSyntaxError\b/i,
    /unexpected token/i,
    /failed to fetch/i,
    /\bnetwork error\b/i,
    /^request failed$/i,
    /<!DOCTYPE/i,
    /<html/i,
    /\bat\s+\w+/i,
];

export const isInternalReportError = (error: string): boolean => {
    const trimmed = error.trim();
    if (!trimmed) return true;
    if (INTERNAL_ERROR_CODES.has(trimmed)) return true;
    return TECHNICAL_ERROR_PATTERNS.some((pattern) => pattern.test(trimmed));
};

export const resolveReportErrorMessage = (
    error: string,
    t: TFunction
): string => {
    switch (error) {
        case REPORT_ERROR_CODE.TIMEOUT:
            return t('mapReportTimeoutHint');
        case REPORT_ERROR_CODE.EMPTY:
            return t('mapReportEmptyResult');
        case REPORT_ERROR_CODE.NETWORK:
            return t('mapReportNetworkFailure');
        case REPORT_ERROR_CODE.INTERNAL:
        case 'request_failed':
            return t('mapReportInternalError');
        default:
            if (isInternalReportError(error)) {
                return t('mapReportInternalError');
            }
            return error;
    }
};

export const sanitizeReportErrorCode = (error: string): string => {
    if (isInternalReportError(error)) {
        return REPORT_ERROR_CODE.INTERNAL;
    }
    return error;
};
